import React from 'react'
import IconCard from '../../../components/landingPage/IconCards/SquaredIconCard'
import Button from '../../../components/landingPage/Button'
import Section from "../../landingPage/Section";
import { useHistory } from 'react-router-dom';
import {
  AccessToAITechnologies, 
  BetterProsthetic, 
  CertifiedProtocols,
  ConsistentPredictable,
  Chairside,
  GlobalReach,
  HighPrecision,
  IncreaseProductivity,
  LowContactDentistry,
  NearZero,
  ReducedChair,
  SingleVisit
} from '../../../images/index'

function PartnerBenefits() {
  const history = useHistory();

  return (
    <Section title="XiViX Partner Benefits" className="text-center py-8 md:py-12" id="PartnerBenefits">
      <div className="grid grid-cols-3 xl:grid-cols-4 mx-1 2xl:mx-32 max-w-screen-3xl place-content-center">
        <IconCard icon={SingleVisit} description="Single Visit Dentistry"/>
        <IconCard icon={LowContactDentistry} description="Low Contact dentistry"/>
        <IconCard icon={HighPrecision} description="High-precision 3D scanners"/>
        <IconCard icon={NearZero} description="Near Zero Errors"/>
        <IconCard icon={ConsistentPredictable} description="Consistent & Predictable Outcomes"/>
        <IconCard icon={BetterProsthetic} description="Better Prosthetic Fit"/>
        <IconCard icon={Chairside} description="XiViX Chairside solutions"/>
        <IconCard icon={ReducedChair} description="Reduced Chair Time & Costs"/>
        <IconCard icon={IncreaseProductivity} description="Increased Productivity"/>
        <IconCard icon={CertifiedProtocols} description="Certified Protocols & Dental Materials"/>
        <IconCard icon={AccessToAITechnologies} description="Access to AI-Technologies"/>
        <IconCard icon={GlobalReach} description="Global Reach, Synergy & Economy of Scale"/>
      </div>
      <Button text="Join us and become a XiViX Partner" primary="blackBorder" className="mt-10" onClick={() => history.push('/professional/become-a-partner')}/>
    </Section>
  )
}

export default PartnerBenefits
